import { TimezoneSelect } from '@hakimo-ui/hakimo/feature-shared';
import { LocationFormData } from '@hakimo-ui/hakimo/types';
import { InputField } from '@hakimo-ui/shared/ui-base';

interface Props {
  formData: LocationFormData;
  onChange: (data: LocationFormData) => void;
  onRemove?: () => void;
}

export function LocationFormCard(props: Props) {
  const { formData, onChange } = props;

  const updateField = (field: keyof LocationFormData) => (value: string) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 relative rounded-xl">
      <div className="px-6 py-6">
        <div className="space-y-4 pt-1">
          <InputField
            label="Name"
            value={formData.name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateField('name')(e.target.value)
            }
            type="text"
            placeholder="Enter location name"
          />

          <InputField
            label="Street"
            value={formData.street}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateField('street')(e.target.value)
            }
            type="text"
            placeholder="Enter street address"
          />

          <div className="grid grid-cols-2 gap-4">
            <InputField
              label="City"
              value={formData.city}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('city')(e.target.value)
              }
              type="text"
              placeholder="Enter city"
            />
            <InputField
              label="State"
              value={formData.state}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('state')(e.target.value)
              }
              type="text"
              placeholder="Enter state"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <InputField
              label="Country"
              value={formData.country}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('country')(e.target.value)
              }
              type="text"
              placeholder="Enter country"
            />
            <div>
              <TimezoneSelect
                value={formData.timezone}
                onChange={updateField('timezone')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationFormCard;
